import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';

import { DAYANAK_ETIKETI, onIzinOnayla, onIzinReddet, type OnIzinOzeti } from '../api/on-izin';
import type { Kimlik } from '../api/tipler';
import { GerekceDiyalogu } from '../bilesenler/Diyalog';
import { tarihMetni } from '../bicim/tarih';

/**
 * ÖN İZİN ONAY/RED DİYALOĞU — iki liste paylaşıyor.
 *
 * `MesaiOnIzni` ekranında hem "Tümü" hem "Onay bekleyenler" sekmesi aynı
 * karar akışını kullanıyor. Ekran dosyasında bırakılsaydı ya kod iki kez
 * yazılır ya ESLint `rules-of-hooks` kuralına takılırdı: proje kancaları
 * Türkçe `...Kullan` ekiyle adlandırıyor ve kural istisnası YALNIZ
 * `src/kancalar/` klasörüne verilmiş (bkz. `eslint.config.mjs`).
 */
export function onIzinKararKullan() {
  const sorguIstemcisi = useQueryClient();
  const [eylem, eylemYaz] = useState<{ o: OnIzinOzeti; tur: 'onay' | 'red' } | null>(null);

  const karar = useMutation({
    mutationFn: (girdi: { id: Kimlik; tur: 'onay' | 'red'; metin: string }) =>
      girdi.tur === 'onay'
        ? // `aciklama` İSTEĞE BAĞLI (`OnayDto`) — boşsa hiç gönderilmez.
          onIzinOnayla(girdi.id, girdi.metin === '' ? undefined : girdi.metin)
        : onIzinReddet(girdi.id, girdi.metin),
    onSuccess: async () => {
      await sorguIstemcisi.invalidateQueries({ queryKey: ['on-izin'] });
      eylemYaz(null);
    },
  });

  const diyalog =
    eylem === null ? null : (
      <GerekceDiyalogu
        baslik={eylem.tur === 'onay' ? 'Ön izni onayla' : 'Ön izni reddet'}
        aciklama={
          `${eylem.o.birimAd} · ` +
          `${tarihMetni(eylem.o.baslangicTarihi)} – ${tarihMetni(eylem.o.bitisTarihi)} · ` +
          `${eylem.o.tahminiSaat} sa × ${eylem.o.tahminiKisi} kişi · ` +
          DAYANAK_ETIKETI[eylem.o.dayanak]
        }
        etiket={eylem.tur === 'onay' ? 'Açıklama' : 'Red gerekçesi'}
        ipucu={
          eylem.tur === 'onay'
            ? 'İsteğe bağlı — onay denetim izine yazılır.'
            : 'Zorunlu — talep eden neden reddedildiğini bilmeli.'
        }
        onayEtiketi={eylem.tur === 'onay' ? 'Onayla' : 'Reddet'}
        onayTuru={eylem.tur === 'onay' ? 'birincil' : 'tehlike'}
        zorunluMu={eylem.tur === 'red'}
        enCokKarakter={500}
        bekliyor={karar.isPending}
        hata={karar.error}
        kapat={() => eylemYaz(null)}
        onayla={(metin) => karar.mutate({ id: eylem.o.onIzinId, tur: eylem.tur, metin })}
      />
    );

  return { eylemYaz, diyalog };
}
